<template>
  <v-container fluid class="main">
    <v-row>
      <v-col cols="12">
          <h1>방문 절차 안내</h1>
          <v-row class="visit-step-row" no-gutters>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 01</v-chip>
                      <v-img src="/img/icon01.svg" max-height="45"></v-img>
                      <v-card-title>방문 신청</v-card-title>
                      <v-card-text>방문자 예약 신청을 진행하세요</v-card-text>
                  </v-card>
              </v-col>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 02</v-chip>
                      <v-img src="/img/icon02-2.svg" max-height="45"></v-img>
                      <v-card-title>방문 교육 이수</v-card-title>
                      <v-card-text>사전 보안·안전 교육을 수강하고 이수하세요</v-card-text>
                      <div class="visit-step-edu">
                          교육 이수 이력의 유효기간은 {{ $code.get('service.education.education_day') }}일입니다.
                      </div>
                  </v-card>
              </v-col>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 03</v-chip>
                      <v-img src="/img/icon02.svg" max-height="45"></v-img>
                      <v-card-title>방문자 통보</v-card-title>
                      <v-card-text>접견자에게 방문예약 정보가 전달됩니다</v-card-text>
                  </v-card>
              </v-col>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 04</v-chip>
                      <v-img src="/img/icon03.svg" max-height="45"></v-img>
                      <v-card-title>내부 승인</v-card-title>
                      <v-card-text>담당자의 승인 결과를 확인하세요</v-card-text>
                  </v-card>
              </v-col>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 05</v-chip>
                      <v-img src="/img/icon04.svg" max-height="45"></v-img>
                      <v-card-title>방문 수속</v-card-title>
                      <v-card-text>당일 QR 인증하여 방문증을 수령하세요</v-card-text>
                  </v-card>
              </v-col>
              <v-col>
                  <v-card color="var(--card-bg-color, #f1f4fb)">
                      <v-chip label color="var(--card-accent-color, #448eff)">Step 06</v-chip>
                      <v-img src="/img/icon05.svg" max-height="45"></v-img>
                      <v-card-title>방문</v-card-title>
                      <v-card-text>안내에 따라 접견을 진행하고 종료 후 방문증을 반납하세요</v-card-text>
                  </v-card>
              </v-col>
          </v-row>
      </v-col>
      <v-col cols="12">
          <h1>방문예약 서비스 소개</h1>
          <v-card class="visit-info-card">
              <v-card-text>
                <p>방문을 원하시는 분은 <span>「방문 예약 신청」</span>를 클릭하여 방문 예약을 해주세요.</p>
                <p>신청 내역은 <span>「방문 예약 내역 조회」</span>를 클릭하면 확인이 가능합니다.</p>
              </v-card-text>
              <v-card-actions>
                    <v-btn
                           to="/home/agreeTerms"
                           color="var(--primary-color, #023894)"
                           dark
                           depressed
                           large
                    >
                        방문 예약 신청
                    </v-btn>
                    <v-btn
                           to="/home/search"
                           color="var(--primary-color, #023894)"
                           outlined
                           depressed
                           large
                    >
                        방문 예약 내역 조회
                    </v-btn>
              </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
p {
    font: 1rem 'NanumSquare', sans-serif;
}
</style>